import React, { useState } from 'react';

import CalendarProducts from '../../components/CalendarProducts/CalendarProducts';
import CalendarShippingForm from '../../components/CalendarShippingForm/CalendarShippingForm';
import CalendarPage from '../CalendarPage/CalendarPage';


function CalendarPurchase(props) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [secondStep, setSecondStep] = useState(false);

  return (
    <CalendarPage>
      {!secondStep ? (
        <CalendarProducts
          selectedPaymentMethod={selectedPaymentMethod}
          selectedProduct={selectedProduct}
          setSecondStep={setSecondStep}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          setSelectedProduct={setSelectedProduct}
        />
      ) : (
        <CalendarShippingForm history={props.history} />
      )}
    </CalendarPage>
  );
}

export default CalendarPurchase;
